import React, { createContext, useContext, useState, ReactNode } from 'react';

export type DesignSpanContextType = {
	maxSpanIn: number | null;
	setMaxSpanIn: (value: number | null) => void;
	maxCantileverIn: number | null;
	setMaxCantileverIn: (value: number | null) => void;
};

export const DesignSpanContext = createContext<DesignSpanContextType | null>(
	null
);

export function DesignSpanProvider({ children }: { children: ReactNode }) {
	const [maxSpanIn, setMaxSpanIn] = useState<number | null>(null);
	const [maxCantileverIn, setMaxCantileverIn] = useState<number | null>(null);

	return (
		<DesignSpanContext.Provider
			value={{
				maxSpanIn,
				setMaxSpanIn,
				maxCantileverIn,
				setMaxCantileverIn,
			}}
		>
			{children}
		</DesignSpanContext.Provider>
	);
}

export function useDesignSpanContext() {
	const context = useContext(DesignSpanContext);
	if (!context) {
		throw new Error(
			'useDesignSpanContext must be used within DesignSpanProvider'
		);
	}
	return context;
}
